import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { Error404Component } from '../pages/error/404.component';
import { RegisterComponent } from '../pages/register/register.component';
import { LayoutComponent } from '../components/layout/layout.component';
import { authProviders, AuthGuard } from '../auth.guard';
import { ViewScheduleComponent } from '../pages/view-schedule/view-schedule.component';
import { VaccinationComponent } from '../pages/view-schedule/vaccination.component';
import { LandingComponent } from '../pages/landing/landing.component';
import { ActiveLinkComponent } from '../pages/active-link/active-link.component';
import { UpdatePatientInforComponent } from '../pages/update-patient-information/update-patient-information.component';
import { FluVaccineComponent } from '../pages/flu-vaccine/flu-vaccine.component';
import { CreatePasswordComponent } from '../pages/create-password/create-password.component';
import { LoginComponent } from '../pages/login/login.component';

// main routing
const appRoutes: Routes = [
    {
      path: "landing",
      redirectTo: 'landing/login',
      pathMatch: 'full'
    },
    {
      path: "landing/:action/:username",
      component: LandingComponent
    },
    {
      path: "landing/:action",
      component: LandingComponent
    },
    {
      path: "login/:username",
      component: LoginComponent
    },
    {
      path: "login",
      component: LoginComponent
    },
    {
      path: 'active-link',
      component: ActiveLinkComponent
    },
    { path: 'flu-vaccine/:id', component: FluVaccineComponent },
    {
        path: 'update-patient-information',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: '../pages/update-patient-information/update-patient-information.component.module#UpdatePatientInforModule'
            }
        ]

    },
    {
      path: 'home',
      component: LayoutComponent,
      canActivate: [AuthGuard],
      children: [
          {
              path: '',
              loadChildren: '../pages/information/information.module#InformationModule'
          }
      ]

  },
    {
        path: 'register',
        component: RegisterComponent
    },
    {
      path: 'register/:centreCode',
      component: RegisterComponent
    },
    {
        path: 'change-password',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: '../pages/change-password/change-password.module#ChangePassModule',
            },
        ]
    },
    {
        path: 'create-password/:id',
        component: CreatePasswordComponent
    },
    {
        path: 'request-appointment',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: '../pages/request-appointment/request-appointment.module#RequestAppointmentModule'
            }
        ]
    },
    {
        path: 'view-schedule',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: '../pages/view-schedule/view-schedule.module#ViewScheduleModule'
            }
        ]

    },
    {
        path: 'vaccination',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: '../pages/view-schedule/vaccination.module#VaccinationModule'
            }
        ]

    },
    /* {
        path: 'view-schedule/:id',
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadChildren: '../pages/view-schedule/view-schedule.module#ViewScheduleModule'
            }
        ]

    }, */
    /*   {
          path: 'search-patient',
          component: LayoutComponent,
          canActivate: [AuthGuard],
          children: [
              {
                  path: '',
                  loadChildren: '../pages/search-patient/search-patient.module#SearchPatientModule'
              }
          ]
      },
      {
          path: 'add-patient',
          component: LayoutComponent,
          canActivate: [AuthGuard],
          children: [
              {
                  path: '',
                  loadChildren: '../pages/add-patient/add-patient.module#AddPatientModule'
              }
          ]
      },
      {
          path: 'administration',
          canActivate: [AuthGuard],
          children: [
              {
                  path: '',
                  loadChildren: '../pages/administration/administration.module#AdministrationModule',
              },
          ]
      },*/
    {
        path: 'admin-vaccine',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: '../pages/admin-vaccine/admin-vaccine.module#AdminVaccineModule'
            }
        ]
    },
    {
        path: 'view-uploaded-documents',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: '../pages/view-uploaded-documents/view-uploaded-documents.module#ViewUploadedDocumentsModule'
            }
        ]
    },
    {
        path: 'view-invoices',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: '../pages/view-invoices/view-invoices.module#ViewInvoicesModule'
            }
        ]
    },
    {
        path: 'view-prescriptions',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: '../pages/view-prescriptions/view-prescriptions.module#ViewPrescriptionsModule'
            }
        ]
    },
    {
        path: 'view-medical-conditions',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: '../pages/view-medical-conditions/view-medical-conditions.module#ViewMedicalConditionsModule'
            }
        ]
    },
    {
        // default routes
        path: '',
        redirectTo: 'landing/login',
        pathMatch: 'full'
    },
    {
        path: '**', component: Error404Component
    }, // 404
];


@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        AuthGuard
    ]
})

export class AppRoutingModule {
}






// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/routes/app.routing.module.ts